<template>
    <div class="mt-4">
        <p class="block text-sm leading-5 text-gray-700 font-bold">
            Join the waiting list
        </p>

        <p class="text-sm text-gray-600">
            This date is currently fully booked. If you want to be notified if space becomes available, please join the
            waiting list below.
        </p>

        <special-button type="button"
                     @click.prevent.native="showWaitingListModal = true"

        >
            Join the Waiting List
        </special-button>


        <portal to="modal">
            <modal v-if="showWaitingListModal">
                <h2>Join the Waiting List.</h2>

                <template v-if="! waitingListSuccess">
                    <p class="text-gray-600 mb-6">
                        Please add me to the waiting list for the {{ eventName }} event on the {{ eventDate }}.
                    </p>

                    <form @submit.prevent="signUpToWaitingList"
                          class="mt-2"
                    >
                        <div class="grid sm:grid-cols-2 gap-6">
                            <form-input v-model="form.first_name"
                                        label="First Name"
                                        for="waiting_list_first_name"
                                        id="waiting_list_first_name"
                                        name="waiting_list_first_name"
                                        :required="true"
                                        :error="getErrorFor('first_name')"
                            ></form-input>

                            <form-input v-model="form.last_name"
                                        label="Last Name"
                                        for="waiting_list_last_name"
                                        id="waiting_list_last_name"
                                        name="waiting_list_last_name"
                                        :required="true"
                                        :error="getErrorFor('last_name')"
                            ></form-input>

                            <form-input v-model="form.email"
                                        type="email"
                                        label="Email"
                                        for="waiting_list_email"
                                        id="waiting_list_email"
                                        name="waiting_list_email"
                                        :required="true"
                                        :error="getErrorFor('email')"
                            ></form-input>

                            <form-input v-model="form.phone"
                                        label="Phone"
                                        for="waiting_list_phone"
                                        id="waiting_list_phone"
                                        name="waiting_list_phone"
                                        :required="true"
                                        :error="getErrorFor('phone')"
                            ></form-input>
                        </div>

                        <div class="grid sm:grid-cols-2 gap-6 mt-8">
                            <form-button type="submit"
                                         class="sm:order-2"
                            >
                                Add Me
                            </form-button>

                            <form-button colour="white"
                                         class="sm:order-1"
                                         @click.prevent.native="cancelWaitingList"
                            >
                                Cancel
                            </form-button>
                        </div>
                    </form>
                </template>

                <template v-else>
                    <p class="text-gray-600 mb-6">
                        You have successfully been added to the waiting list for the {{ eventName }} event on the
                        {{ eventDate }}.
                    </p>

                    <div class="grid gap-6 mt-8">
                        <form-button colour="white"
                                     class="sm:order-1"
                                     @click.prevent.native="cancelWaitingList"
                        >
                            Close
                        </form-button>
                    </div>
                </template>
            </modal>
        </portal>
    </div>
</template>

<script>
    import FormInput from "./form/Input";
    import FormButton from "./form/Button";
    import SpecialButton from "./form/public/Button";
    import Modal from "./Modal";

    import Form from "../mixins/Form";

    export default {
        data() {
            return {
                showWaitingListModal: false,
                waitingListSuccess: false,

                form: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                }
            }
        },

        props: {
            eventDateId: {
                type: Number,
                required: true,
            },

            eventName: {
                type: String,
                required: true
            },

            eventDate: {
                type: String,
                required: true
            }
        },

        components: { FormInput, FormButton, SpecialButton, Modal },

        mixins: [Form],

        methods: {
            signUpToWaitingList() {
                this.post(`/waiting-list/${this.eventDateId}`)
                    .then(response => {
                        this.waitingListSuccess = true;
                    });
            },

            cancelWaitingList() {
                this.showWaitingListModal = false;

                this.form.first_name = '';
                this.form.last_name = '';
                this.form.email = '';
                this.form.phone = '';
                this.waitingListSuccess = false;
            }
        }
    }
</script>
